import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const HomeSectionTitle: FCX = ({
    children,
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn('HomeSection__title', className)}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    );
};

export default HomeSectionTitle;